import { fg } from '@atlaskit/platform-feature-flags';
import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

export const setLocalStorageItem: (key: string, value: string) => void = (key: string, value: string): void => {
	if (fg('search_page_use_browser_storage_controls')) {
		AtlBrowserStorageLocal.setItem(key, value);
	} else {
		localStorage.setItem(key, value);
	}
};

export const getLocalStorageItem: (key: string) => any = (key: string): any => {
	const item = fg('search_page_use_browser_storage_controls')
		? AtlBrowserStorageLocal.getItem(key)
		: localStorage.getItem(key);
	return item ? JSON.parse(item) : null;
};

export const getLocalStorageItemAsString: (key: string) => string | null = (key: string) => {
	const item = fg('search_page_use_browser_storage_controls')
		? AtlBrowserStorageLocal.getItem(key)
		: localStorage.getItem(key);
	return item ? item : null;
};

export const removeLocalStorageItem: (key: string) => void = (key: string): void => {
	if (fg('search_page_use_browser_storage_controls')) {
		AtlBrowserStorageLocal.removeItem(key);
	} else {
		localStorage.removeItem(key);
	}
};
